import { render, staticRenderFns } from "./DraftComparePage.vue?vue&type=template&id=66b5bdd6"
import script from "./DraftComparePage.vue?vue&type=script&lang=js"
export * from "./DraftComparePage.vue?vue&type=script&lang=js"
import style0 from "./DraftComparePage.vue?vue&type=style&index=0&id=66b5bdd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports